import { ImpersonateCarrierService } from './impersonate-carrier.service';
import { ChangeCarrierComponent } from './../components/change-carrier/change-carrier.component';
import { CustomerSupportComponent } from './../components/customer-support/customer-support.component';
import { Injectable } from '@angular/core';
import { ExternalMenuItems } from '../enum/external-menu-items.enum';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/core/services/config.service';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import * as _ from 'lodash';
import { ModalService } from 'src/app/shared/services/modal.service';
import { ContactSupportComponent } from 'src/app/components/contact-support/contact-support.component';
import { OrganizationTypesEnum } from 'src/app/shared/enum/organization-types.enum'
import { TutorialUrlsEnum } from 'src/app/shared/enum/tutorial-urls.enum'
import { UserRoleEnum } from 'src/app/shared/enum/user-role.enum'
import { TokenStorageService } from 'src/app/core/security/token-storage-service';
@Injectable({
  providedIn: 'root'
})
export class RedirctUrlService {

  private entitlements: any;
  constructor(
    private router: Router,
    private config: ConfigService,
    private currentUserService: CurrentUserService,
    private impersonateCarrierService: ImpersonateCarrierService,
    private modal: ModalService,
    private tokenService: TokenStorageService
  ) { }

  /**
   * Redirect login goes here
   *  */
  public async onRedirectHandler($event) {
    const isCordovaApp = document.URL.indexOf('http://') === -1
      && document.URL.indexOf('https://') === -1;
    this.entitlements = await this.currentUserService.getEntitlements();
    const userEntitlementsArray = Object.keys(this.entitlements)
    if ($event['title'] === 'My Account' && userEntitlementsArray.includes('HC_CR_VIEW_USER')) {
      if (isCordovaApp) {
        window.location.href = `../carriers/index.html`;
      } else {
        const config = await this.config.getConfig();
        const baseUrl = `https://hubconnect${config.runtime.envName}.hubgroup.com`;
        window.location.href = `${baseUrl}/carriers/my-account`;
        return;
      }
    }
    const externalCustMenuItems = Array.from(
      Object.keys(ExternalMenuItems.CUSTOMER).map(k => ExternalMenuItems.CUSTOMER[k as any])
    );

    const externalSuppMenuItems = Array.from(
      Object.keys(ExternalMenuItems.SUPPLIER).map(k => ExternalMenuItems.SUPPLIER[k as any])
    );

    const externalCarrierMenuItems = Array.from(
      Object.keys(ExternalMenuItems.CARRIER).map(k => ExternalMenuItems.CARRIER[k as any])
    )


    if ((externalCustMenuItems.findIndex(menu => menu === $event['title']) > -1) && $event['app'] == "CUSTOMER") {
      if (isCordovaApp) {
        window.location.href = `../customers/index.html?appRedirectUrl=${$event['url']}`;
      } else {
        // Redirect to customer app
        const config = await this.config.getConfig();
        const baseUrl = `https://hubconnect${config.runtime.envName}.hubgroup.com`;
        window.location.href = `${baseUrl}/customers${$event['url']}`;
      }
    } else if ((externalSuppMenuItems.findIndex(menu => menu === $event['title']) > -1) && $event['app'] == "SUPPLIER") {
      if (isCordovaApp) {
        window.location.href = `../suppliers/index.html?appRedirectUrl=${$event['url']}`;
      } else {
        // Redirect to supplier app
        const config = await this.config.getConfig();
        const baseUrl = `https://hubconnect${config.runtime.envName}.hubgroup.com`;
        window.location.href = `${baseUrl}/suppliers${$event['url']}`;
      }
    } else if ((externalCarrierMenuItems.findIndex(menu => menu === $event['title']) > -1) && $event['app'] == "CARRIER") {
      if (isCordovaApp) {
        window.location.href = `../carriers/index.html`;
      } else {
        // Redirect to carrier app
        const config = await this.config.getConfig();
        const baseUrl = `https://hubconnect${config.runtime.envName}.hubgroup.com`;
        window.location.href = `${baseUrl}/carriers${$event['url']}`;
      }
    } else {
      this.router.navigateByUrl($event['url']);
    }

  }

  public async navigateToBaseUrl() {
    const config = await this.config.getConfig();
    window.location.href = `https://hubconnect${config.runtime.envName}.hubgroup.com`
  }

  /**
 * Logout Logic goes here
 *  */
  public async onLogoutHandler(event) {
    if (event.url.includes('my-account')) {
      event.title = 'My Account'
      this.onRedirectHandler(event);
    } else if (event.url.includes('tutorial')) {
      if (this.currentUserService.user.organizationType === OrganizationTypesEnum.INTERNAL) {
        if (this.currentUserService.user.role.type === UserRoleEnum.HC_INTERNAL_SUPPLIER_ADMIN) {
          window.open(TutorialUrlsEnum.SUPPLIER, "_blank")
        }
        else {
          window.open(TutorialUrlsEnum.CUSTOMER, "_blank")
        }
      }
      else if (this.currentUserService.user.organizationType === OrganizationTypesEnum.SUPPLIER) {
        window.open(TutorialUrlsEnum.SUPPLIER, "_blank")
      }
      else {
        window.open(TutorialUrlsEnum.CUSTOMER, "_blank")
      }
      return;
    } else if (event.url.includes('contact-support')) {
      this.modal.open(ContactSupportComponent, {}, { panelClass: 'mat-dialog-no-padding' })
    } else if (event.url.includes('announcements')) {
      this.router.navigateByUrl('/announcements');
      return;
    } else if (event.url.includes('/user-support')) {
      this.modal.open(CustomerSupportComponent, {});
      return;
    } else if (event.url.includes('/carrier-support')) {
      this.modal.open(ChangeCarrierComponent, {}, { panelClass: 'carrier-change-dialog' });
      return;
     } else if (event.url.includes('/support-mode')) {
      this.impersonateCarrierService.carrierChanged();
      return;
    } else if (event.url.includes('/switch-profile')) {
      await this.tokenService.getProfileToken()
        .then(async (response: any) => {
          const config = await this.config.getConfig();
          window.location.href = `https://hubconnect${config.runtime.envName}.hubgroup.com`;
        });
    } else {
      this.currentUserService.logout();
    }
  }
}
